module.exports = __webpack_public_path__ + "static/media/excel.37fd3275.svg";